export const profileConstants = {
  LOADING_PROFILE_START: 'LOADING_PROFILE_START',
  LOADING_PROFILE_SUCCESS: 'LOADING_PROFILE_SUCCESS',
  LOADING_PROFILE_ERROR: 'LOADING_PROFILE_ERROR',
};
